<template>
    <tailwind-layout title="Property Payment">
        <div class="bg-white border border-gray-200 shadow-xl sm:rounded-lg p-6 mt-9">
            <div class="text-center m-8">
                <h1 class="text-2xl font-bold text-blue-600 mb-4">Payment Request Successfully Received</h1>
                <p class="text-lg text-gray-600">We have received your rent payment request of ${{paid_amount}}. It will be processed in the next 5-7 business days. Please check your email for more details.</p>
                <inertia-link :href="redirect_url" class="mt-8 w-1/2 sm:w-1/5 sm:ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-gray-900 bg-gold-500 hover:bg-gold-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Go back
                </inertia-link>
            </div>
        </div>
    
    <!-- Demo Widget -->
    <DemoWidget
        :page-identifier="'rented-properties.payment-succeeded'"
        :steps="demoSteps"
        :auto-start="true"
        :show-help-icon="true"
    />
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue';
import DemoWidget from '@/Components/DemoWidget.vue'
import { getDemoSteps } from '@/Config/demoSteps.js'
import FormButton from '@/Shared/FormButton.vue';
import SelectInput from '@/Shared/SelectInput.vue';
import SwitchGroup from "@/Shared/SwitchGroup.vue";
import RadioGroup from "@/Shared/RadioGroup.vue";
import BannedCitiesAndStates from "@/Shared/BannedCitiesAndStates.vue";
import axios from "axios";

export default {
    props: {
        redirect_url: String,
        paid_amount: String,
    },
    components: {
        TailwindLayout,
        FormButton,
        SelectInput,
        RadioGroup,
        DemoWidget
    },
    remember: 'form',
    data() {
        return {
            demoSteps: getDemoSteps('rented-properties.payment-succeeded')
        }
    }
}
</script>
